<script setup lang="ts">
import IconClose from "@/icons/IconClose.vue";
import IconSubmit from "@/icons/IconSubmit.vue";
import {useCartStore} from "@/stores/cartStore";
import {ref} from "vue";

const cartStore = useCartStore();
const email = ref('');

const handleSubmit = () => {
  cartStore.provideDiscountCodeEmail(email.value)
}
const handleClear = () => {
  cartStore.removeDiscountCode();
}
</script>

<template>
  <div :class="{
    'email-box': true,
    'hidden': cartStore.discountData.error_code !== 'opc_1'
  }">
    <div :class="{
      'coupon-code-message coupon-code-message_confirm': true,
      'is-active': cartStore.discountData.error_code === 'opc_1'
    }">
      <p class="coupon-code-message__main">Your coupon <strong>{{ cartStore.discountData.code }}</strong> is verified successfully</p>
      <p class="coupon-code-message__second">Please enter your email to validate your coupon code:</p>
    </div>
    <input type="email" aria-label="E-mail" class="email-box__input input" placeholder="johndoe@email.com" data-type="email" data-required="email" v-model="email">
    <button class="email-box-btn Button Button--primary" @click="handleSubmit">
      <IconSubmit />
      <span class="hidden-phone">Submit</span>
    </button>
    <button class="email-box__close" @click="handleClear"><IconClose /></button>
  </div>
</template>